// These are just thin-wrappers around the gtag function.
// The primary purpose is to manage our own object of global parameters that are passed to GA4 on every event sent via `RankersAnalytics.track()`.
// The compiled bundle is rendered inline within the `app/views/layouts/shared/analytics/_google_analytics.html.erb` partial.

if (typeof window.RankersAnalytics === 'undefined') window.RankersAnalytics = {};
if (typeof window.RankersAnalytics.globalParameters === 'undefined') window.RankersAnalytics.globalParameters = {};
if (typeof window.RankersAnalytics.EventName === 'undefined') window.RankersAnalytics.EventName = {};
if (typeof window.RankersAnalytics.ParameterKey === 'undefined') window.RankersAnalytics.ParameterKey = {};

// This function should generally _not_ be accessed directly - use the `eventTracker` function for tracking events.
// Note the 'event_callback' option! This is a special case parameter that gets handled by GA (see https://developers.google.com/analytics/devguides/collection/gtagjs/sending-data#implement_event_callback_functions)
window.RankersAnalytics.track = function (eventName, options = {}) {
    if (window.RankersAnalytics.isGtagUndefined('track', arguments)) return;
    const globalOptions = window.RankersAnalytics.globalParameters;
    const allOptions = {...globalOptions, ...options};
    gtag('event', eventName, allOptions);
    console.log(`[RankersAnalytics] 'track' function called for event '${eventName}' with options:`, allOptions);
};

// @param {String} eventName - The type of interaction (e.g. a custom event like 'BRAND_VIEWED' or a recommended event like 'ad_impression' )
// @param {object} options - customer parameters (key/value pairs) (eg. { 'nav_pane_id' : 'INTRO_PANE' }
// Recommended events should be used over custom events whenever possible (see recommended events at https://support.google.com/analytics/answer/9267735)
// Our custom events should be UPPERCASE_UNDERSCORED eg. 'NAV_OPTION_SELECTED' and 'INSERT_VIEWED'.
window.RankersAnalytics.eventTracker = function (eventName, options = {}) {
    window.RankersAnalytics.track(eventName, options);
};

window.RankersAnalytics.isGtagUndefined = function(functionName, args) {
    if (typeof window.gtag === "undefined") {
        console.warn(`[RankersAnalytics] 'gtag' is not defined. '${ functionName }' function called with arguments:`, args);
        return true;
    }
    return false;
};

window.RankersAnalytics.addGlobalParameters = function(options) {
    window.RankersAnalytics.globalParameters = {...window.RankersAnalytics.globalParameters, ...options};
};